import React from 'react';
import { Container } from 'react-bootstrap';

export function Footer() {
  return (
    <footer style={{ backgroundColor: '#222', color: '#fff', padding: '20px 0', boxShadow: '0px -25px 20px -20px rgba(0,0,0,0.45)' }}>
      <Container>
        <p style={{ margin: 0, textAlign: 'center'}}>© 2024 Dina Stojilkovic. All Rights Reserved.</p>
        <p style={{ margin: 0, textAlign: 'center'}}>Created by Stefan Stojilkovic</p>
      </Container>
    </footer>
  );
}

